import type { ArabicTerm } from '../data/arabicTerms';
import { settings } from '../state';
import { SayArabic } from './SayArabic';

/** An Arabic name on a card, shown only with Arabic switched on. */
export function ArabicTermRow({ term, label }: { term?: ArabicTerm; label: string }) {
  if (!settings.value.arabic || !term) return null;
  return (
    <div class="arabic">
      <div class="row-label">{label}</div>
      <div class="arabic-top">
        <span class="arabic-names">
          <span class="arabic-script" lang="ar" dir="rtl">{term.ar}</span>
          <span class="arabic-tr">{term.tr}</span>
        </span>
        <SayArabic text={term.ar} name={term.tr} />
      </div>
      {term.meaning && <div class="arabic-meaning">“{term.meaning}”</div>}
      {term.note && <div class="arabic-note" dir="auto">{term.note}</div>}
    </div>
  );
}
